import { useTranslation } from 'react-i18next';

import type { LinkPreview } from '@/entities/board';

import styles from './LinkPreview.module.css';

/**
 * Read-only summary of the site behind a link card, under the (always editable, always raw)
 * title. The preview never replaces what the user typed.
 */
export function LinkPreviewSummary({ preview }: { preview: LinkPreview }) {
  const { t } = useTranslation();
  return (
    <div className={styles.summary} data-testid="link-summary" data-status={preview.status}>
      {preview.image_url && <img className={styles.image} src={preview.image_url} alt="" />}
      <div className={styles.text}>
        {preview.status === 'failed' && (
          <p className={styles.muted}>{t('cards.linkUnavailable')}</p>
        )}
        {preview.status === 'pending' && <p className={styles.muted}>{t('cards.linkLoading')}</p>}
        {preview.title && <strong>{preview.title}</strong>}
        {preview.description && <p className={styles.description}>{preview.description}</p>}
        <a href={preview.url} target="_blank" rel="noopener noreferrer" className={styles.host}>
          {preview.site_name ?? preview.hostname} ↗
        </a>
      </div>
    </div>
  );
}
